import { Inject, Injectable } from '@angular/core';
import { Card } from '@shared/models';
import { GenericCrudService, getCrudName } from '@shared/modules/crud';
import { DefaultRessourceStore } from '@shared/services/stores/default-ressource-store.service';

@Injectable()
export class CardStore extends DefaultRessourceStore<Card> {
    constructor(@Inject(getCrudName(Card)) protected crudService: GenericCrudService<Card>) { super(crudService) }
}